import { constants } from "../../../constants";

export default class OpenGame {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        this.gb.emitters.emit.web.gameLaunchUrl(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            default:
                event["getLaunchUrlFromWallet"] = this._default;
        }

        return event;
    }
}
